import { connect } from "react-redux";

import {
  updateDlsUserMaterial,
  removeDlsUserMaterial
} from "~/store/ducks/user/dlsUserMaterials";
import { removeNote } from "~/store/ducks/user/notes";
import { removePresentationMarker } from "~/store/ducks/user/presentationMarkers";

import EditModal from "./EditModal";

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: formData => {
    dispatch(updateDlsUserMaterial(formData));
    ownProps.hideModal();
  },
  onDelete: formData => {
    dispatch(removeDlsUserMaterial(formData._id));
    dispatch(removeNote(formData._id));
    dispatch(removePresentationMarker(formData._id));
    ownProps.hideModal();
  }
});

export default connect(null, mapDispatchToProps)(EditModal);
